// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Qr","icon":"e_Rr"};